<template>
    <div class="upload-picture-modal">
        <b-modal
                id="user-guide"
                title="User Guide"
                :size="getModalClass"
                :click-to-close="false"
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
        >
            <!--<div class="">-->
                <!--<b-carousel id="carousel" :interval="0" controls @sliding-end="onSlideEnd">-->
                    <!--<b-carousel-slide v-for="(iframe, index) in iframes" :key="index">-->
                        <!--<label>{{iframe.label}}</label>-->
                        <!--<iframe :src="iframe.url" width="100%" height="315px" frameborder="0" allowfullscreen ref="iframeRef"></iframe>-->
                    <!--</b-carousel-slide>-->
                <!--</b-carousel>-->
            <!--</div>-->

            <div class="row">
                <div class="col-md-9">
                    <div class="iframe-section">
                        <iframe :src="currentSrc" width="100%" height="520" frameborder="0" allowfullscreen ref="iframeRef"></iframe>
                        <label class = "mt-1 ml-2">{{currentLabel}}</label>
                    </div>
                </div>

                <div class="col-md-3 margin-custom vertical-separator">
                    <div class="row mb-2" v-for="(iframe, index) in iframes" :key="index">
                        <div class="col-sm-12" :class="{ 'selectedVideo': selectedIndex === index }">
                        <span class="">
                            <a @click="changeVideo(index)">
                                <img :src="iframe.thumbnail" style="height: 80px;"/>
                                <label class = "mt-1 ml-2">{{iframe.label}}</label>
                            </a>
                        </span>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div v-else class="row">-->
                <!--<div class="col-sm-12">-->
                    <!--<p>Kindly click the download button.</p>-->
                <!--</div>-->
            <!--</div>-->
            <template #modal-footer="{}">
                <b-button size="sm" variant="primary" >
                    <a style="color: white;text-decoration: none" :href="FILE_URL" target="_blank" download>Download Manual</a>
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        // props: {
        //     item: {
        //         type: Object,
        //         default: null,
        //     },
        // }, // End of Component > props
        computed: {
            ...mapGetters([
                'user'
            ]),
            getModalClass()
            {
                this.changeItems()
                // return this.user.accountType=='lite' ? 'sm' : 'lg'
            }
        }, // End of Component > computed
        methods: {
            changeVideo(index)
            {
                this.currentSrc=this.iframes[index].url
                this.currentLabel=this.iframes[index].label
                this.selectedIndex = index
            },
            onSlideEnd(index) {
                // Pause the video when the carousel slide changes
                const iframe = this.$refs.iframeRef[index];
                if (iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            },
            changeItems()
            {
                if(this.user.accountType=='lite')
                {
                    this.FILE_URL=process.env.VUE_APP_URL+'api/files/users/user-manual-lite.pdf'
                    this.currentSrc= "https://www.idenfodirect.com/wp-content/uploads/2024/03/Onboarding-Video-Explainer.mp4"
                    this.currentLabel="Getting Started"
                    this.iframes= [
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail1.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Onboarding-Video-Explainer.mp4',
                        label:"Getting Started"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail2.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video2.mp4',
                        label:"How to onboard customers"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail3.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video3.mp4',
                        label:"Platform features"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail4.png',
                        url: 'https://www.idenfodirect.com/wp-content/uploads/2024/03/Idenfo-Video4_1.mp4',
                        label:"Configurations, team members and system logs"
                    },
                ]
                }
            }
        },
        data() {
            return {
                selectedIndex : 0,
                FILE_URL:process.env.VUE_APP_URL+'api/files/users/user-manual.pdf',
                currentSrc: "https://tutorials.idenfo.com/Video-01-How-to-Get-Started.mp4",
                currentLabel:"How to Get Started",
                iframes: [
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail01.png',
                        url: 'https://tutorials.idenfo.com/Video-01-How-to-Get-Started.mp4',
                        label:"How to Get Started"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail02.png',
                        url: 'https://tutorials.idenfo.com/Video-02-Onboarding-Individuals-and-Companies.mp4',
                        label:"Onboarding Individuals and Companies"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail03.png',
                        url: 'https://tutorials.idenfo.com/Video-03-Bulk-Upload-Onboarding.mp4',
                        label:"Bulk Upload Onboarding"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail04.png',
                        url: 'https://tutorials.idenfo.com/Video-04-Handling-Alerts-and-Reviewing-Risk.mp4',
                        label:"Handling Alerts and Reviewing Risk"
                    },
                    {
                        thumbnail:process.env.VUE_APP_URL+'api/files/logo/thumbnail05.png',
                        url: 'https://tutorials.idenfo.com/Video-05-Profiles-Permissions-and-Admin-Tools.mp4',
                        label:"Profiles, Permissions and Admin Tools"
                    }
                ],
            };
        },

    }
</script>
<style>
    .guide-link
    {
        color: #000;
        text-decoration: none;
    }
    .carousel-caption
    {
        position: initial !important;
    }
    .carousel-control-next, .carousel-control-prev
    {
        height: 100px !important;
        top: 121px !important;
    }
    .selectedVideo {
        border-right: 1px solid #ccc;
        padding-right: 30px!important;
    }
    .vertical-separator {
        border-left: 1px solid #ccc; /* Adjust border color and style as needed */
        height: 100%; /* Adjust the height to match the height of the items */
        /*margin-right: 10px; !* Adjust the margin to control the spacing between items *!*/
    }
    .margin-custom {
        /*margin-top: 32px;*/
        /*overflow-y: scroll;*/
    }
    .iframe-section {
        padding: 0;
    }
</style>
